import React from "react";
import { FaInstagram, FaLinkedin, FaFacebook, FaEnvelope } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../assets/leo.jpeg";
import { useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = () => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const el = document.getElementById("contact");
        el?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const el = document.getElementById("contact");
      el?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className="bg-white shadow md:px-12">
        <div className="w-full px-8 mx-auto py-8 md:py-8">
          <div className="sm:flex sm:items-center sm:justify-between ">
            <a href="/" className="flex items-center mb-4 sm:mb-0">
              <img src={logo} className="w-16" alt="Flowbite Logo" />
              <a
                href="https://www.instagram.com/leoclub_du/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram
                  size={20}
                  className="inline-block ml-4 mb-1 text-gray-700"
                />
              </a>
              <a
                href="https://www.facebook.com/OurLeoclubDU/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook
                  size={20}
                  className="inline-block ml-4 mb-1 text-gray-700"
                />
              </a>
              <a
                href="https://www.linkedin.com/school/leo-club-university-of-delhi/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin
                  size={20}
                  className="inline-block ml-4 mb-1 text-gray-700"
                />
              </a>
              <a
                href="https://x.com/leo_delhi"
                target="_blank"
                rel="noreferrer"
              >
                <FaXTwitter
                  size={20}
                  className="inline-block ml-4 mb-1 text-gray-700"
                />
              </a>
              <a
                href="mailto:duleosclub@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaEnvelope
                  size={20}
                  className="inline-block ml-4 mb-1 text-gray-700"
                />
              </a>
            </a>
            <ul className="flex flex-wrap items-center mb-6 text-md font-medium text-gray-600 sm:mb-0 ">
              <li>
                <a
                  href="#contact"
                  onClick={handleContactClick}
                  className="mr-4 hover:underline md:mr-6 "
                >
                  Contact Us
                </a>
              </li>
              {/* <li>
                <a href="/donate" className="mr-4 hover:underline md:mr-6">
                  Donate Us
                </a>
              </li> */}
            </ul>
          </div>

          <hr className="my-6 h-[1.5px]  bg-gray-500 border-0 rounded " />
          <span className="block text-sm font-semibold text-gray-700 sm:text-center ">
            © 2026 Leo Club University of Delhi. All Rights Reserved.
          </span>
        </div>
      </footer>
    </>
  );
}
